export function canEditRole(role: string): boolean {
  return role === "founder" || role === "admin" || role === "moderator";
}

export function canAdminRole(role: string): boolean {
  return role === "founder" || role === "admin";
}
